<div class="custom-control custom-switch custom-switch-md">
  <input 
    type="checkbox" 
    class="custom-control-input" 
    id="{{ id }}"
    />
  <label class="custom-control-label" for="{{ id }}"></label>
</div>
